<template>
  <div class="app-container">
    <ent-info ref="entInfo"></ent-info>
  </div>
</template>
<script>
// import api from "@/api/sys/user";
import entInfo from "@/components/ent/ent/info";

export default {
  name: "ent",
  components: {
    entInfo,
  },
  data() {
    return {};
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$refs.entInfo.getData();
    },
  },
};
</script>